import { createClient } from "../client"

export async function getSupportConversationMessages(conversationId: string) {
    const supabase = createClient()
    
    return await supabase
        .from('support_messages')
        .select('*')
        .eq('conversationId', conversationId)
        .order('createdAt')
}

export async function sendMessage(
    conversationId: string, 
    content: string, 
    isAdmin: boolean
) {
    const supabase = createClient()
    
    return await supabase
        .from('support_messages')
        .insert({
            conversationId,
            isAdmin,
            content,
            fileIds: [],
            readAt: null
        })
        .select()
}

export async function markMessagesAsRead(
    messageIds: string[]
) {
    const supabase = createClient()
    
    return await supabase
        .from('support_messages')
        .update({ 
            readAt: new Date().toISOString() 
        })
        .in('id', messageIds)
}

export async function markConversationMessagesAsRead(
    conversationId: string, 
    isAdmin: boolean
) {
    const supabase = createClient()
    
    // Mark all messages from the other party as read
    return await supabase
        .from('support_messages')
        .update({ 
            readAt: new Date().toISOString() 
        })
        .eq('conversationId', conversationId)
        .eq('isAdmin', !isAdmin) // Only mark messages from the other side as read
        .is('readAt', null) // Only update unread messages
}

export async function getUnreadMessagesCount(
    userId: string,
    isAdmin: boolean
) {
    const supabase = createClient()
    
    if (isAdmin) {
        // For admin, count unread messages across all conversations
        const { count, error } = await supabase
            .from('support_messages')
            .select('*', { count: 'exact', head: true })
            .eq('isAdmin', false) // Only count messages from users
            .is('readAt', null) // Only count unread messages
        
        return { count: count || 0, error }
    } else {
        // For regular user, count unread messages in their conversations
        const { data: conversations } = await supabase
            .from('support_conversations')
            .select('id')
            .eq('userId', userId)
        
        if (!conversations || conversations.length === 0) {
            return { count: 0, error: null }
        }
        
        const conversationIds = conversations.map(c => c.id)
        
        const { count, error } = await supabase
            .from('support_messages')
            .select('*', { count: 'exact', head: true })
            .in('conversationId', conversationIds)
            .eq('isAdmin', true) // Only count messages from admin
            .is('readAt', null) // Only count unread messages
        
        return { count: count || 0, error }
    }
} 

export async function getLastConversations() {
    const supabase = createClient()
    
    return await supabase
        .from('support_conversations')
        .select('*')
        .order('createdAt', { ascending: false })
        .limit(20)
}